<template>
  <v-row justify="center" align="start" class="fill-height">
    <v-col class="pt-10" cols="12" align="center">
      <span class="text-h2 font-weight-bold grey--text text--darken-3">
        {{ $t('default') }}
      </span>
    </v-col>
    <v-col cols="10" class="py-2" align-self="center">
      <v-row class="fill-height" align="center" justify="center">
        <v-col align="center" v-for="(page, index) in $t('homepages')" :key="index" :cols="page.colLength" class="mb-5">
          <v-card @click="goto(page)" class="menuItem d-flex flex-column align-center justify- " color="primary"
            :height="menu.height" :width="menu.width" elevation="5">
            <v-img :src="page.displayIcon.url" :width="menu.imageWidth" contain>
            </v-img>
            <v-card-text class="pb-0 text-h5 white--text font-weight-bold">
              {{ page.pageName }}
            </v-card-text>
            <v-card-text class="pt-0 text-subtitle-1 white--text">
              {{ page.desc }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-divider class="pb-6 mx-10"></v-divider>
      <languageBar></languageBar>
    </v-col>
  </v-row>
</template>

<script>
import languageBar from '@/components/languageBar'
import { mapGetters } from 'vuex'

export default {
  name: 'menuMatrix',
  components: {
    languageBar
  },
  data() {
    return {
      menu: {
        height: null,
        width: null,
        col: null,
        imageWidth: null,
        length: 3
      }
    }
  },
  computed: {
    ...mapGetters(['getCMSlink', 'getTouchCount', 'isUserLooking', 'getAvatarLangCodes', 'getMaps', 'getKioskProfile', 'getKioskLocation', 'getApplicationId', 'getApplicationSessionId'])
  },
  watch: {
    getKioskProfile(newVal) {
      if (newVal.data().modules.length !== this.length) {
        this.length = newVal.data().modules.length
        this.$store.dispatch('indentifyModuleLang', {
          module: this.getKioskProfile.data().modules,
          language: this.getKioskProfile.data().languages
        }).then(() => {
          this.$store.dispatch("createApolloConnection", this.getKioskProfile.data().cmsLink + '/graphql').then(response => {
            this.$store.dispatch("fetchHomePage")
          })
        })
      }
    }
  },
  methods: {
    goto(page) {
      this.$store.commit('setRequestQna', false)
      this.$store.commit("setIsThinking", false)
      this.$store.commit("setSpeechRecognitionHandler", false);
      let date = new Date()
      if (this.getTouchCount === 0) {
        this.$store.dispatch("addSessionDatatoStrapi", {
          applicationId: this.getApplicationId,
          applicationSessionId: this.getApplicationSessionId,
          actionType: "Session Started",
          sessionPayload: {},
          timeStamp: date.toISOString(),
        })
        this.$store.commit('setTouchCount', this.getTouchCount + 1)
      }

      if (page.pageType.length !== 0) {
        switch (page.pageType[0].__typename) {
          case 'ComponentHomepageNavigation':

            this.$router.push('/' + page.pageType[0].pathName.toLowerCase());
            this.$store.commit('setPageHeader', page.pageType[0].pageHeader)
            this.$store.commit('setQnaKeyword', '')

            // To start session using touch - when no face detected
            if (!this.isUserLooking) {


              this.$store.dispatch("addSessionDatatoStrapi", {
                applicationId: this.getApplicationId,
                applicationSessionId: this.getApplicationSessionId,
                actionType: "Touch",
                sessionPayload: {
                  module: "Homepage",
                  action: "navigate",
                  response: page.pageType[0].pathName
                },
                timeStamp: date.toISOString(),
              })

            }
            this.$store.commit('setDefaultBubbleText', true)
            this.$store.dispatch('avatarSpeak', page.speech)
            break;
          case 'ComponentHomepageDialogBox':
            if (page.pageType[0].type === 'map') {
              let mapPath = this.getMaps.get(page.pageType[0].mapName.toLowerCase())
              let floorName = this.$i18n.t('floors').filter(floor => floor.floorNumber === mapPath.mapFloor)
              this.$store.dispatch('avatarSpeak', mapPath.speech)
              this.$store.dispatch('openImageViewer', {
                name: mapPath.mapName,
                url: mapPath.mapImage,
                floor: floorName[0].floorName,
                showQR: false,
                qrUrl: ""
              })
            } else if (page.pageType[0].type === 'textList') {
              if (page.pageType[0].textList === 'jano') {
                this.$store.commit("setCheckinOptionViewer", true)
                this.$store.dispatch('avatarSpeak', "Do you have a Lawyer or Public Defender to represent you?")
                this.$store.dispatch("addSessionDatatoStrapi", {
                  applicationId: this.getApplicationId,
                  applicationSessionId: this.getApplicationSessionId,
                  actionType: "Touch",
                  sessionPayload: {
                    module: "Homepage",
                    action: "Jano",
                    response: page.pageName
                  },
                  timeStamp: date.toISOString(),
                })
              } else {
                this.$store.dispatch("addSessionDatatoStrapi", {
                  applicationId: this.getApplicationId,
                  applicationSessionId: this.getApplicationSessionId,
                  actionType: "Touch",
                  sessionPayload: {
                    module: "Homepage",
                    action: "Open Popup",
                    response: page.pageName
                  },
                  timeStamp: date.toISOString(),
                })
                let options = page.pageType[0].textList.split(",")
                this.$store.dispatch('openJuryOptionsViewer', {
                  dialogHeader: this.$i18n.t('selectTrafficeOptionMsg'),
                  dialogData: options,
                })
              }
            } else if (page.pageType[0].type === 'url') {
              this.$store.dispatch("addSessionDatatoStrapi", {
                applicationId: this.getApplicationId,
                applicationSessionId: this.getApplicationSessionId,
                actionType: "Touch",
                sessionPayload: {
                  module: "Homepage",
                  action: "Open URL",
                  response: page.pageName
                },
                timeStamp: date.toISOString(),
              })
              window.open(page.pageType[0].textList, '_blank');
            }
            break;
          default:
            break;
        }
      }

    },
  },
  mounted() {
    if (this.$i18n.t('homepages').length <= 4) {
      this.menu = {
        height: 255,
        width: 280,
        col: 5,
        imageWidth: "45%"
      }
    } else if (this.$i18n.t('homepages').length <= 6) {
      this.menu = {
        height: 260,
        width: 250,
        col: 4,
        imageWidth: "45%"
      }
    }
  }
}
</script>

<style>
.menuItem {
  border-radius: 20px !important;
}

.footer {
  bottom: 0 !important;
}
</style>

<i18n>
    {
      "en": {
          "default": "How Can I Help You Today?"
        },
      "es":{
          "default": "¿Cómo puedo ayudarlo?"
        }
    }
  </i18n>